import { render, staticRenderFns } from "./CommentsPopup.vue?vue&type=template&id=82c0ae5e"
import script from "./CommentsPopup.vue?vue&type=script&lang=js"
export * from "./CommentsPopup.vue?vue&type=script&lang=js"
import style0 from "./CommentsPopup.vue?vue&type=style&index=0&id=82c0ae5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports